<template>
    <b-container fluid v-if="loaded">
        <app-modal
            title="Aviso de pago pendiente"
            id="pending_payment-window"
            size="xl"
            centered
            :header-bg-variant="!venueBlocked ? 'warning' : 'danger'"
            :body-bg-variant="!venueBlocked ? 'warning' : 'danger'"
            :footer-bg-variant="!venueBlocked ? 'warning' : 'danger'"
            header-text-variant="white"
            body-text-variant="white"
            no-close-on-backdrop
            no-close-on-escs
            hide-header-close
            hide-footer
        >
            <b-row align-v="center">
                <template v-if="!venueBlocked">
                    <b-col cols="12" md="12">
                        <span style="font-size: 2rem; font-weight: bold">
                            {{
                                'Por favor recuerde realizar el pago de su licencia por valor de $' +
                                this.licensePrice +
                                '. El sistema ha identificado que a la fecha tiene una mora de ' +
                                this.daysLate +
                                ' días. Puede realizar el pago a través de PSE en el siguiente '
                            }}
                        </span>
                        <a
                            href="https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago?idConv=00018589&origen=buscar"
                            target="_blank"
                            style="font-size: 2rem; font-weight: bold"
                            >link</a
                        >
                        <span style="font-size: 2rem; font-weight: bold">
                            {{ 'y enviar el comprobante a pagos@intuscolombia.com. Si ya realizó el pago por favor omita este mensaje.' }}
                        </span>
                    </b-col>
                    <b-button @click="next" variant="primary" class="button-desaign">Aceptar y continuar</b-button>
                </template>
                <template v-else>
                    <b-col cols="12" md="12">
                        <span style="font-size: 2rem; font-weight: bold">
                            {{
                                'Actualmente su licencia se encuentra suspendida. Por favor recuerde realizar el pago por valor de $' +
                                this.licensePrice +
                                '. El sistema ha identificado que a la fecha tiene una mora de ' +
                                this.daysLate +
                                ' días. Puede realizar el pago a través de PSE en el siguiente '
                            }}
                        </span>
                        <a
                            href="https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago?idConv=00018589&origen=buscar"
                            target="_blank"
                            style="font-size: 2rem; font-weight: bold"
                            >link</a
                        >
                        <span style="font-size: 2rem; font-weight: bold">
                            {{ 'y enviar el comprobante a pagos@intuscolombia.com. Si ya realizó el pago por favor omita este mensaje.' }}
                        </span>
                    </b-col>
                </template>
            </b-row>
        </app-modal>
        <div class="d-flex justify-content-center">
            <app-client-banner v-if="isReseller && !!currentClient"></app-client-banner>
            <app-vecindapp-banner v-else />
        </div>
        <b-row align-h="center">
            <b-col cols="auto">
                <app-sub-title>Seleccione la sede</app-sub-title>
            </b-col>
        </b-row>
        <div v-if="!!venues.length">
            <b-row align-h="center">
                <b-col cols="auto">Unidad - Sede</b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" lg="8">
                    <b-form-input v-model="term" placeholder="Buscar" autofocus></b-form-input>
                </b-col>
            </b-row>
            <b-row v-for="venue in theVenues" :key="venue.id" align-h="center">
                <b-col class="my-2" cols="12" lg="8">
                    <b-btn variant="primary" block @click="selectVenue(venue)">{{ venue.unit.name }} - {{ venue.name }}</b-btn>
                </b-col>
            </b-row>
        </div>
        <b-row v-if="noVenues">
            <b-col>
                <b-alert show variant="warning">No tiene ninguna sede asociada.</b-alert>
            </b-col>
        </b-row>
        <app-vecindapp-banner-footer size="sm" v-if="isReseller && currentClient"></app-vecindapp-banner-footer>
    </b-container>
</template>
<script>
import * as mutations from '@store/_mutations'
import * as actions from '@store/_actions'
import { mapMutations, mapActions } from 'vuex'
import appClientBanner from '@layout/ClientBanner'
import appVecindappBannerFooter from '@layout/VecindappBannerFooter'
export default {
    components: {
        appClientBanner,
        appVecindappBannerFooter,
    },
    data: () => ({
        venues: [],
        loaded: false,
        term: '',
        venueBlocked: false,
        daysLate: '',
        licensePrice: 0,
    }),
    computed: {
        noVenues() {
            return !!this.loaded && !this.venues.length
        },
        theVenues() {
            if (!this.term) return this.venues
            return this.venues.filter(
                (item) =>
                    item.name.toLowerCase().indexOf(this.term.toLowerCase().trim()) !== -1 ||
                    item.unit.name.toLowerCase().indexOf(this.term.toLowerCase().trim()) !== -1
            )
        },
    },
    methods: {
        ...mapMutations({
            setCurrentVenue: mutations.SET_CURRENT_VENUE,
            setCurrentClient: mutations.SET_CURRENT_CLIENT,
            setCurrentUnit: mutations.SET_CURRENT_UNIT,
            setCapabilities: mutations.SET_CAPABILITIES,
        }),
        ...mapActions({
            loadPersonCapabilities: actions.LOAD_PERSON_CAPABILITIES,
        }),
        async selectVenue(venue) {
            const { data } = await this.$repo.get(
                `people`,
                {
                    venueId: venue.id,
                    userId: this.currentUser.id,
                }
                // `people/venues/${venue.id}/users/${this.currentUser.id}`
            )

            if (!data.length === 0) {
                toastr.error('El usuario no tiene una persona en representación de esta sede')
                return this.$router.push({ name: 'login' })
            }

            const person = data[0]
            this.setCurrentPerson(person)
            this.loadPersonCapabilities(person.id)

            const unit = venue.unit
            const client = unit.client
            this.setCurrentUnit(unit)
            this.setCurrentVenue(venue)
            // Send venue ID to backend to store in session
            // await this.$repo.post('session/venue', {
            //     venue_id: venue.id
            // })

            // await this.$repo.post('session/client', {
            //     client_id: client.id
            // })

            this.currentProfile.slug !== 'interno' ? this.validatePendingPayments() : this.next()
            // Si es reseller el cliente no se modifica porque se carga de acuerdo al dominio
            !this.isReseller && this.setCurrentClient(client)
            // this.next()
        },

        validatePendingPayments() {
            const venue = this.currentVenue
            this.licensePrice = venue.license_price
            let lastPaymentDate = moment(venue.last_payment_date)
            let currentDate = moment()
            let dueDate = lastPaymentDate.clone().add(6, 'days').startOf('day')
            this.daysLate = Math.max(currentDate.diff(dueDate, 'days'), 0)
            if (venue.pending_payment_date && !venue.blocked) {
                this.venueBlocked = false
                this.loaded = true
                this.$nextTick(() => this.openModal('pending_payment-window'))
            } else if (venue.blocked) {
                this.venueBlocked = true
                this.loaded = true
                this.$nextTick(() => this.openModal('pending_payment-window'))
            } else {
                this.next()
            }
        },
        next() {
            return this.$router.push({
                name: this.currentProfile.default_screen,
            })
        },
        async loadVenues() {
            const params = {
                with: 'unit.client;modules',
            }

            this.isReseller && !!this.currentClient && (params['clientId'] = this.currentClient.id)

            const { data } = await this.$repo.get(`users/${this.currentUser.id}/profiles/${this.currentProfile.id}/venues`, params)

            this.venues = data.sort((a, b) => (b.unit.name < a.unit.name ? 1 : -1))
            if (data.length === 1) {
                return this.selectVenue(data[0])
            }
            this.loaded = true
        },

        // async loadPersonCapabilities() {
        //     const { data } = await this.$repo.get(`people/${this.currentPerson.id}/capabilities`)
        //     const caps = Array.isArray(data) ? data : Object.values(data)
        //     const capabilities = Array.from(new Set([...this.capabilities, ...caps]))
        //     this.setCapabilities(capabilities)
        // },
    },
    created() {
        this.loadVenues()
    },
    mounted() {
        //
    },
}
</script>
<style>
.button-desaign {
    margin: 0 auto;
    display: block;
    margin-top: 10px;
}
</style>
